export default __webpack_public_path__ + "static/media/img-3.2e2e61c4.jpg";